const withHttpTimeout = (timeout = 5000): AbortSignal => {
    const controller = new AbortController();

    setTimeout(() => controller.abort(), timeout);

    return controller.signal;
};

export { withHttpTimeout };
